import type { SelectRowAction } from "../types/action";
import type { Row5, YinshState } from "../types/game-state";

function rowStillValid(row: Row5, board: YinshState["board"]): boolean {
  return row.positions.every((pos) => {
    const cell = board[pos] ?? null;
    return cell?.type === "MARKER" && cell.player === row.player;
  });
}

function positionsMatch(
  a: readonly [string, string, string, string, string],
  b: readonly [string, string, string, string, string],
): boolean {
  const setA = new Set(a);
  return b.every((p) => setA.has(p));
}

export function applySelectRow(
  state: YinshState,
  action: SelectRowAction,
): YinshState {
  // Remove 5 markers from board
  const newBoard = { ...state.board };
  for (const pos of action.positions) {
    newBoard[pos] = null;
  }

  // Remove the matched pending row, drop any that are now invalid
  const remaining = state.pendingRows
    .filter((row) => !positionsMatch(row.positions, action.positions))
    .filter((row) => rowStillValid(row, newBoard));

  return {
    ...state,
    board: newBoard,
    // The 5 removed markers go back to the shared pool (rule.md §"Resolving a
    // Row": "remove them from the board (return to pool)"). Without this, the
    // pool only ever decreases and games force-end via marker exhaustion after
    // exactly markersTotal (51) placements, long before anyone scores 3 rings.
    markersPool: state.markersPool + action.positions.length,
    pendingRows: remaining,
    rowsRemovedThisTurn: state.rowsRemovedThisTurn + 1,
  };
}
